import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=9655d10c&"
import script from "./Other.vue?vue&type=script&lang=js&"
export * from "./Other.vue?vue&type=script&lang=js&"
import style0 from "./Other.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports